var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMapIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99913 2.7161C4.20961 2.7161 1.94094 5.00242 1.94094 7.81364C1.94094 9.044 2.37608 10.2186 3.17049 11.1476L3.32363 11.3188L6.99913 15.0229L10.6856 11.3089C11.5716 10.3563 12.0584 9.11647 12.0584 7.81364C12.0584 5.00242 9.78865 2.7161 6.99913 2.7161ZM9.51825 7.75183C9.51825 6.35002 8.39062 5.21362 6.99978 5.21362C5.60879 5.21362 4.48116 6.35002 4.48116 7.75183C4.48116 9.15364 5.60879 10.2899 6.99978 10.2899C8.39062 10.2899 9.51825 9.15364 9.51825 7.75183Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8128 7.81364C13.8128 3.90545 10.5716 0.759302 6.64945 0.956883C3.1517 1.13303 0.328741 4.01087 0.191896 7.5376C0.116237 9.48545 0.844538 11.2562 2.06704 12.552L6.20022 16.7182L6.28603 16.7964C6.72981 17.1613 7.3845 17.1353 7.79816 16.7184L11.9444 12.5399L12.1064 12.361C13.1664 11.1492 13.8128 9.5596 13.8128 7.81364ZM1.94094 7.81364C1.94094 5.00242 4.20961 2.7161 6.99913 2.7161C9.78865 2.7161 12.0584 5.00242 12.0584 7.81364C12.0584 9.11647 11.5716 10.3563 10.6856 11.3089L6.99913 15.0229L3.32363 11.3188L3.17049 11.1476C2.37608 10.2186 1.94094 9.044 1.94094 7.81364Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMapIc);
export default __webpack_public_path__ + "static/media/MobileMap_ic.2c12bf16.svg";
export { ForwardRef as ReactComponent };